import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDialogModule } from '@angular/material/dialog'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { SatPopoverModule } from '@ncstate/sat-popover'
import { TranslateModule } from '@ngx-translate/core'

import { SendContactEditDialogModule } from '../../send-contact-edit-dialog'
import { InvoiceSubtitleModule } from '../invoice-subtitle'
import { InvoiceCardComponent } from './invoice-card.component'

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatTooltipModule,
    PipesModule,
    RouterModule,
    SatPopoverModule,
    TranslateModule,
    InvoiceSubtitleModule,
    DirectivesModule,
    MatDialogModule,
    SendContactEditDialogModule,
  ],
  declarations: [InvoiceCardComponent],
  exports: [InvoiceCardComponent],
})
export class InvoiceCardModule {}
